import Keycloak from 'keycloak-js';

const USE_MOCK = process.env.REACT_APP_USE_MOCK_AUTH === 'true';

// ── Mock users for UAT (switched via localStorage key 'uat_mock_user') ──
const MOCK_USERS = {
  admin: {
    sub: '00000001-0000-0000-0000-000000000001',
    preferred_username: 'admin',
    given_name: 'Admin',
    family_name: 'CloserAcademy',
    resource_access: {
      'realm-management': { roles: [] },
      'accesos-formacion': { roles: ['admin', 'fase-practica', 'finalizada-formacion'] },
    },
  },
  alumno: {
    sub: '00000002-0000-0000-0000-000000000002',
    preferred_username: 'alumno',
    given_name: 'Alumno',
    family_name: 'Base',
    resource_access: {
      'realm-management': { roles: [] },
      'accesos-formacion': { roles: [] },
    },
  },
  'alumno-fase': {
    sub: '00000003-0000-0000-0000-000000000003',
    preferred_username: 'alumno-fase',
    given_name: 'Alumno',
    family_name: 'Fase Práctica',
    resource_access: {
      'realm-management': { roles: [] },
      'accesos-formacion': { roles: ['fase-practica'] },
    },
  },
  'alumno-final': {
    sub: '00000004-0000-0000-0000-000000000004',
    preferred_username: 'alumno-final',
    given_name: 'Alumno',
    family_name: 'Finalizado',
    resource_access: {
      'realm-management': { roles: [] },
      'accesos-formacion': { roles: ['finalizada-formacion'] },
    },
  },
};

function getMockProfile() {
  try {
    const key = window.localStorage.getItem('uat_mock_user') || 'admin';
    return MOCK_USERS[key] || MOCK_USERS.admin;
  } catch { return MOCK_USERS.admin; }
}

// ── Mock (local dev) ──────────────────────────────────────────
const mockKeycloak = {
  authenticated: true,
  get tokenParsed() { return getMockProfile(); },
  logout: () => console.log('[Mock] Logout'),
};

let _initPromise = null;

export const initKeycloak = USE_MOCK
  ? async () => true
  : () => {
      if (!_initPromise) {
        _initPromise = realKeycloak.init({
          onLoad:           'login-required',
          checkLoginIframe: false,
        });
      }
      return _initPromise;
    };

// ── Real (production) ─────────────────────────────────────────
const realKeycloak = USE_MOCK
  ? mockKeycloak // never actually used when mock is on
  : new Keycloak({
      url:      process.env.REACT_APP_KEYCLOAK_URL    || 'https://keycloak.closeracademy.app',
      realm:    process.env.REACT_APP_KEYCLOAK_REALM  || 'CloserAcademy',
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT || 'accesos-formacion',
    });

const keycloakAPI = USE_MOCK ? mockKeycloak : realKeycloak;

export default keycloakAPI;
